export const loader = {
    namespaced: true,
    state: {
        loading: false
    },
    actions: {
        setLoading({commit}, payload) {
            commit("setLoading", payload);
        }
    },
    mutations: {
        setLoading(state, payload) {
            state.loading = payload;
        },}
};
